import { ConfigsService, UrlService } from '@sm360/widget-commons-core-services';
import { Vehicle, Quote, ShowroomService } from '@sm360/widget-commons-vehicle';

const { QuoteActions, QuoteService } = Quote;
const { VehicleActions } = Vehicle;

// function dispatchAddToGarage() {
//     const $window = WindowProxy.get();
//     if ($window) {
//         $window.document.dispatchEvent(new Event(EVENTS.GARAGE_ADDED));
//     }
// }

// function addVehicles(vehicles) {
//     return { type: types.ADD_VEHICLES, vehicles };
// }

// function setInvalidState(isInvalid = true) {
//     return { type: types.INVALID_STATE, payload: isInvalid };
// }

// function setPurchaseMethod(currentQuote, defaultPurchaseMethod) {
//     let purchaseMethod;
//     // Update the purchase method with the quote purchase method
//     purchaseMethod = PurchaseMethodsService.selectPurchaseMethod(defaultPurchaseMethod, currentQuote.purchaseMethod);
//     // Update the finance term for the purchase method
//     if (currentQuote.purchaseMethod === PurchaseMethodsConstant.FINANCE) {
//         purchaseMethod = PurchaseMethodsService.selectTerm(purchaseMethod, currentQuote.finance.term.term);
//         purchaseMethod = PurchaseMethodsService.selectPaymentFrequency(
//             purchaseMethod,
//             currentQuote.finance.paymentFrequency
//         );
//         purchaseMethod = PurchaseMethodsService.setCashDown(purchaseMethod, currentQuote.finance.cashDown);
//     }
//     return purchaseMethod;
// }

// export function setStateAsInvalid() {
//     return (dispatch) => {
//         dispatch(setInvalidState());
//         dispatch(VehicleActions.setVehicle(new VehicleModel()));
//         dispatch(QuoteActions.setQuote(new QuoteModel()));
//         dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(new PurchaseMethodsModel()));
//     };
// }

// export function loadVehiclePayments(vehicle) {
//     return (dispatch, getState) => {
//         const { quote: quoteData } = getState();
//         return ShowroomService.getVehiclePayments(vehicle, '', quoteData)
//             .then((vehiclePayments) => {
//                 dispatch(VehicleActions.setVehicle(vehiclePayments));
//                 const stateData = getState();
//                 const quoteId = UrlService.getUrlParameter('quoteId');

//                 const { quotes } = stateData;
//                 // Get the current quote details from the state
//                 const currentQuote = quotes.filter((quote) => quote.id === quoteId);

//                 // If the current quote is in garage then get the purchase method from it
//                 // If the current quote is not in garage use the default purchase method
//                 const purchaseMethod =
//                     currentQuote.length > 0
//                         ? setPurchaseMethod(currentQuote[0], vehiclePayments.purchaseMethods)
//                         : vehiclePayments.purchaseMethods;

//                 dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(purchaseMethod));
//                 dispatch(VehicleActions.setPurchaseMethods(purchaseMethod));

//                 const state = getState();

//                 dispatch(QuoteActions.setQuotePurchaseMethods(state.purchaseMethods));
//                 const { tradeInVehicle } = state;
//                 if (!tradeInVehicle.id) {
//                     if (AccountService.isAuthenticated()) {
//                         dispatch(TradeInVehicleActions.loadTradeInVehicle(tradeInVehicle));
//                     } else {
//                         const defaultPurchaseMethods = new PurchaseMethodsModel();
//                         dispatch(PurchaseMethodsActions.setTradeIn(defaultPurchaseMethods.tradeIn));
//                         dispatch(PurchaseMethodsActions.setLien(defaultPurchaseMethods.lien));
//                     }
//                 }
//             })
//             .catch(() => {
//                 dispatch(setStateAsInvalid());
//             });
//     };
// }

// export function loadVehiclesPayments(vehicles, purchaseMethod, termMinimum, termMaximum) {
//     return (dispatch) => {
//         return ShowroomService.getVehiclesPayments(vehicles, purchaseMethod, termMinimum, termMaximum)
//             .then((vehiclesPayments) => {
//                 dispatch(addVehicles(vehiclesPayments));
//             })
//             .catch((error) => {
//                 throw error;
//             });
//     };
// }

// export function loadQuote(quoteId) {
//     return (dispatch, getState) => {
//         return ShowroomService.loadQuote(quoteId)
//             .then((quote) => {
//                 dispatch(QuoteActions.setQuote(quote));
//                 dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(quote.vehicle.purchaseMethods));
//                 dispatch(VehicleActions.setPurchaseMethods(quote.vehicle.purchaseMethods));

//                 const state = getState();
//                 const { tradeInVehicle } = state;
//                 if (!tradeInVehicle.id) {
//                     if (AccountService.isAuthenticated()) {
//                         dispatch(TradeInVehicleActions.loadTradeInVehicle(tradeInVehicle));
//                     } else {
//                         const defaultPurchaseMethods = new PurchaseMethodsModel();
//                         dispatch(PurchaseMethodsActions.setTradeIn(defaultPurchaseMethods.tradeIn));
//                         dispatch(PurchaseMethodsActions.setLien(defaultPurchaseMethods.lien));
//                     }
//                 }
//             })
//             .catch(() => {
//                 dispatch(setStateAsInvalid());
//             });
//     };
// }

// export function setQuoteAndVehicle(quoteId, vehicle) {
//     return (dispatch) => {
//         return ShowroomService.loadQuote(quoteId).then((quote) => {
//             dispatch(QuoteActions.setQuote(quote));
//             let securityToken;
//             const windowProxy = WindowProxy.get();
//             if (windowProxy && windowProxy.localStorage) {
//                 securityToken = windowProxy.localStorage.getItem('securityToken');
//             }
//             if (securityToken) {
//                 dispatch(QuoteActions.setQuoteSecurityToken(securityToken));
//             }
//             dispatch(VehicleActions.setVehicle(vehicle));
//             dispatch(QuoteActions.setQuoteVehicle(vehicle));
//             dispatch(VehicleActions.setPurchaseMethods(quote.vehicle.purchaseMethods));
//             // Load vehicle payments at this point to have quote data loaded
//             dispatch(loadVehiclePayments(vehicle));
//         });
//     };
// }

export function setVehicle(vehicle) {
    return (dispatch) => {
        dispatch(VehicleActions.setVehicle(vehicle));
        dispatch(QuoteActions.setQuoteVehicle(vehicle));
    };
}

export function saveToGarage(newAccount, config) {
    return (dispatch, getState) => {
        const location = ConfigsService.getOrganizationUnitLocation();
        const state = getState();
        // Ensure the vehicle is stored in the quote
        dispatch(
            QuoteActions.setQuoteV25(QuoteService.resetQuoteFromVehicleV25(state.quoteV25, location, state.vehicleV25))
        );

        const addToGarageV25 = new Quote.AddToGarageV25();

        dispatch(QuoteActions.setQuoteLoading(true));
        addToGarageV25
            .addOrUpdateQuote(state.quoteV25, newAccount, config)
            .then((quoteId) => {
                UrlService.addOrReplaceParameter('quoteId', quoteId);
                let tries = 0;
                const interval = setInterval(
                    () =>
                        ShowroomService.searchQuoteV25(quoteId)
                            .then((updatedQuote) => {
                                if (updatedQuote.leadId) {
                                    dispatch(QuoteActions.setQuoteV25(updatedQuote));
                                    addToGarageV25.dispatchAddToGarage();
                                    return updatedQuote.leadId;
                                }
                                return undefined;
                            })
                            .finally((leadId) => {
                                if (tries > 5 || leadId) clearInterval(interval);
                                tries += 1;
                            }),
                    2000
                );
            })
            .catch((error) => {
                dispatch(QuoteActions.setQuoteError(error?.message));
            });
    };
}
